// extracted by mini-css-extract-plugin
export default {"container-wrapper":"DragDrop_container-wrapper__zw1ER","container":"DragDrop_container__QNB4J","body":"DragDrop_body__d0qd1","hide":"DragDrop_hide__2Obun"};